import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getReferralslist, getRequestLink } from "../../Api/AffiliateApiCall";


export const fetchAffiliateReferrals = createAsyncThunk(
    "affiliate/fetchAffiliateReferrals",
    async (params = {}, { rejectWithValue }) => {
        try {
            const { status, earning_type, start_date, end_date, type } = params;
            const res = await getReferralslist(status, earning_type, start_date, end_date, type);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load dashboard"
            );
        }
    }
);

export const fetchReferralRequestlink = createAsyncThunk(
    "affiliate/fetchReferralRequestlink",
    async (_, { rejectWithValue }) => {
        try {
            const res = await getRequestLink();
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load dashboard"
            );
        }
    }
);


const AffiliateSlice = createSlice({
    name: "affiliatereferrals",
    initialState: {
        AffiliateReferrals: [],
        RequestReffetallink: [],
        // UsersActivity: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAffiliateReferrals.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAffiliateReferrals.fulfilled, (state, action) => {
                state.loading = false;
                state.AffiliateReferrals = action.payload;
            })
            .addCase(fetchAffiliateReferrals.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchReferralRequestlink.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchReferralRequestlink.fulfilled, (state, action) => {
                state.loading = false;
                state.RequestReffetallink = action.payload;
            })
            .addCase(fetchReferralRequestlink.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
        // fetchReferralRequestlink
    },
});

const AffiliateReferralsReducer = AffiliateSlice.reducer;

export default AffiliateReferralsReducer;
